var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFreshBadge = function SvgFreshBadge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "61px",
    viewBox: "0 0 45 61",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "fresh_icons8-flash-on copy")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elenco-Piatti/Ricette/Ristoranti",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "utente_loggato_men\\xF9",
    transform: "translate(-1216.000000, -1579.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-6",
    transform: "translate(840.000000, 1579.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-flash-on-copy",
    transform: "translate(376.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L45,0 L45,61 C30,51.1975519 22.5,46.2963278 22.5,46.2963278 C22.5,46.2963278 15,51.1975519 0,61 L0,0 Z",
    id: "Path-5-Copy-11",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,21.3111111 L22.76,21.3111111 C26.12,14.437037 27.8,11 27.8,11 C27.8,11 25,11 19.4,11 L11,24.5333333 L20.24,24.5333333 L18.56,40 L32,21.3111111 Z",
    id: "Path",
    fill: "#F4C058",
    fillRule: "nonzero"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFreshBadge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/freshBadge.db27469c.svg";
export { ForwardRef as ReactComponent };